<template>
  <div class="page-container">
   <!-- Loading overlay -->
        <div v-if="loading" class="overlay-modal">
          <b-spinner label="Loading..."></b-spinner>
        </div>



    <div class="page-content">
      <!-- Cabeçalho igual ao PHP -->
      <div class="page-header">
        <div class="d-flex align-items-center mb-3">
          <h1 class="text-white">
            <i class="mdi mdi-view-list"></i> Listagem de Cotações
          </h1>
          
          <div class="d-flex gap-2 ml-auto align-items-center">
            <b-dropdown
              variant="outline-white"
              toggle-class="btn btn-outline-white d-flex align-items-center"
              right
              class="mr-2 mb-2 mb-md-0"
            >
              <template #button-content>
                <i :class="getIcon(current_mode)"></i>
                <span class="d-none d-md-inline-block ml-2">
                  Modo {{ current_mode }}
                </span>
              </template>

              <b-dropdown-item @click="setViewMode('painel')">
                <i
                  class="mdi fa-fw mdi-file-table-box-multiple-outline mr-2"
                ></i>
                Modo Painel
              </b-dropdown-item>
              <b-dropdown-item @click="setViewMode('Listagem')">
                <i class="mdi fa-fw mdi-view-list mr-2"></i>
                Modo Listagem
              </b-dropdown-item>
            </b-dropdown>
            <div class="btn-group">
              <button
                class="btn btn-outline-white"
                v-b-modal.modal-filter
                title="Filtros"
              >
                <i class="fa fa-filter"></i>
                <span class="d-none d-md-inline-block ml-2">Filtros</span>
              </button>
              <button
                class="btn btn-outline-white"
                @click="cleanFilter()"
                title="Limpar Filtros"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Corpo da página -->
      <div class="page-body">

        <!-- Container do card e tabela estilo PHP -->
        <div class="card bg-light-gray">
          <div class="card-body pt-1 bg-light-gray">
            <div class="table-responsive">
              <table
                role="table"
                class="table-v3 custom-table custom-table-quotation no-wrap bg-light-gray"
                aria-busy="false"
                aria-colcount="9"
              >
                <thead>
                  <tr>
                    <th class="nowrap bg-light-gray">ID</th>
                    <th class="nowrap bg-light-gray">TIPO DE SEGURO</th>
                    <th class="nowrap bg-light-gray">SEGURADORA</th>
                    <th class="nowrap bg-light-gray">IS</th>
                    <th class="nowrap bg-light-gray">TOMADOR</th>
                    <th class="nowrap bg-light-gray">SEGURADO</th>
                    <th class="nowrap bg-light-gray">PRÊMIO</th>
                    <th class="nowrap bg-light-gray text-center">STATUS</th>
                    <th class="nowrap bg-light-gray">CRIADO EM</th>
                    <th class="nowrap bg-light-gray">AÇÃO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td data-column-title="ID">{{ item.number }}</td>
                    <td data-column-title="Tipo de Seguro">
                      <span
                        class="truncate-100 truncate-xxl-150"
                        :title="item.type"
                        >{{ item.type }}</span
                      >
                    </td>
                    <td data-column-title="Seguradora">
                      <img
                        v-if="item.insurer_icon"
                        :src="item.insurer_icon"
                        class="logo-seguradora"
                      />
                    </td>
                    <td data-column-title="IS">{{ item.value_insured }}</td>
                    <td data-column-title="Tomador">
                      <span
                        class="truncate-100 truncate-xxl-150"
                        :title="item.taker"
                        >{{ item.taker }}</span
                      >
                    </td>
                    <td data-column-title="Segurado">
                      <span
                        class="truncate-100 truncate-xxl-150"
                        :title="item.insured"
                        >{{ item.insured }}</span
                      >
                    </td>
                    <td data-column-title="Prêmio">
                        {{ item.award ? 'R$ ' + item.award : '' }}
                    </td>
                    <td data-column-title="Status">
                      <div
                        v-if="
                          isMaster() &&
                          (item.status == statusQuotationTypes.DECLINED ||
                            item.status == statusQuotationTypes.ISSUE_FAILURE ||
                            item.status == statusQuotationTypes.DRAFT)
                        "
                      >
                        <span
                          @click="showModalExeption(item)"
                          :class="[
                            'btn btn-sm text-uppercase rounded-pill nowrap d-block',
                            classStatusQuotation(item.status),
                          ]"
                          style="min-width: 117px; margin: 0"
                        >
                          {{
                            getEnumKeyByEnumValue(
                              translateStatusQuotationTypes,
                              item.status
                            )
                          }}
                        </span>
                      </div>
                      <div
                        v-else-if="
                          item.status == statusQuotationTypes.ISSUED &&
                          item.policy_id
                        "
                      >
                        <span 
                          v-b-tooltip.hover
                          :title="'Apólice n. ' + item.policy_number"
                          @click="
                            redirect('details-policy', {
                              policyId: item.policy_id,
                            })
                          "
                          :class="[
                            'btn btn-sm text-uppercase rounded-pill nowrap d-block',
                            classStatusQuotation(item.status),
                          ]"
                          style="min-width: 100px; margin: 0"
                        >
                          {{
                            getEnumKeyByEnumValue(
                              translateStatusQuotationTypes,
                              item.status
                            )
                          }}
                        </span>
                      </div>
                      <div v-else>
                        <span
                          :class="[
                            'btn btn-sm text-uppercase rounded-pill nowrap d-block cursor-default',
                            classStatusQuotation(item.status),
                          ]"
                          style="min-width: 100px; margin: 0"
                        >
                          {{
                            getEnumKeyByEnumValue(
                              translateStatusQuotationTypes,
                              item.status
                            )
                          }}
                        </span>
                      </div>
                    </td>
                    <td data-column-title="Criado em">{{ item.created_at }}</td>
<td data-column-title="Ação" class="actions text-right">
  <div class="btn-group">
    <!-- Botão “Emitir” -->
    <button
      v-if="item.status === statusQuotationTypes.APPROVED && $can('policy-issue')"
      class="btn btn-action"
      @click="redirect('final-feedback-quotation', { quotationId: item.action })"
      v-b-tooltip.hover
      title="Emitir"
    >
      <i class="fas fa-angle-double-right"></i>
    </button>

    <!-- Botão “Editar cotação” -->
    <button
      v-else-if="$can.any(['quotation-store','quotation-update','quotation-edit']) 
      && isNotRentalInsurance(item)"
      class="btn btn-action"
      @click="verifyStatusQuotation(item.status) ? null : editQuotation(item.action, item.status)"
      v-b-tooltip.hover
      title="Editar cotação"
    >
      <i class="fas fa-pen"></i>
    </button>

    <!-- Botão “Visualizar cotação” -->
    <button
      v-if="$can('quotation-show')"
      class="btn btn-action"
      @click="redirect('details-quotation', { quotationId: item.action })"
      v-b-tooltip.hover
      title="Visualizar cotação"
    >
      <i class="fas fa-eye"></i>
    </button>

    <b-dropdown
  variant="link"
  no-caret
  right
  toggle-class="btn btn-action"
  menu-class="dropdown-menu-right border"
>
  <template #button-content>
    <i class="fa fa-ellipsis-v"></i>
  </template>

  <!-- Gerar apólice manualmente -->
  <b-dropdown-item
    v-if="item.status === statusQuotationTypes.APPROVED && isMaster() && isNotRentalInsurance(item)"
    @click="emitQuotation(item.action)"
    title="Gerar apólice manualmente"
  >
    <i class="far fa-handshake"></i>
    Gerar apólice manualmente
  </b-dropdown-item>

  <!-- Emitir -->
  <b-dropdown-item
    v-if="$can('policy-issue') && isNotRentalInsurance(item)"
    @click="redirect('final-feedback-quotation', { quotationId: item.action })"
    title="Emitir"
  >
    <i class="fas fa-angle-double-right"></i>
    Emitir
  </b-dropdown-item>

  <!-- Clonar cotação -->
  <b-dropdown-item
    v-if="$can('quotation-store') && isNotRentalInsurance(item)"
    @click="cloneQuotation(item.action)"
    title="Clonar cotação"
  >
    <i class="far fa-copy"></i>
    Clonar cotação
  </b-dropdown-item>

  <!-- Apagar -->
  <b-dropdown-item
    v-if="$can('quotation-delete')"
    @click="actionAvaiable(item.status) ? null : showModalDestroy(item)"
    title="Apagar"
  >
    <i class="fas fa-trash"></i>
    Apagar
  </b-dropdown-item>
</b-dropdown>

  </div>
</td>

                  </tr>
                </tbody>
              </table>
            </div>
            <div >
              <b-pagination
                @page-click="pageChanged"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                class="my-3 mb-4"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modals section -->
    <b-modal
      id="show-modal"
      ref="showModal"
      size="md"
      class="mt-4"
      hide-footer
      centered
    >
      <template #modal-title>{{ title }}</template>
      <div class="card card-termo-uso mt-1 mb-5">
        <p class="my-4">{{ deletion_data }}</p>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12">
          <button
            @click="$bvModal.hide('show-modal')"
            class="btn btn-outline-secondary btn-lg text-uppercase px-4 mr-1"
          >
            <i class="fa fa-angle-left mr-2"></i>
            <span class="d-none d-md-inline-block"> Voltar</span>
          </button>
          <button
            @click="checkPolice ? checkPolicyExist() : destroyQuotation()"
            class="btn btn-primary btn-lg text-uppercase px-4"
            data-toggle="modal"
            data-target="#modal-cnpj"
          >
            Excluir<i class="fa fa-angle-right ml-2"></i>
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Additional modals for clone, emit, filters, and info -->
    <!-- Modal Clonar Cotação -->
    <b-modal
      id="show-modal-confirm-clone"
      ref="showModalConfirmClone"
      hide-footer
      centered
    >
      <template #modal-title>Confirmação</template>
      <div class="card">
        <p>Deseja clonar essa cotação?</p>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12">
          <button
            @click="$bvModal.hide('show-modal-confirm-clone')"
            class="btn btn-outline-secondary btn-lg text-uppercase px-4 mr-1"
          >
            <i class="fa fa-angle-left mr-2"></i>
            <span class="d-none d-md-inline-block"> Cancelar</span>
          </button>
          <button
            @click="confirmCloneQuotation()"
            class="btn btn-primary btn-lg text-uppercase px-4"
          >
            Confirmar<i class="fa fa-angle-right ml-2"></i>
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Modal Confirmar Emissão -->
    <b-modal
      id="show-modal-confirm-emit"
      ref="showModalConfirmEmit"
      hide-footer
      size="confirmation"
      centered
    >
      <template #modal-title>Confirmação</template>
      <div class="card">
        <p>Deseja emitir apólice desta cotação?</p>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12">
          <button
            @click="$bvModal.hide('show-modal-confirm-emit')"
            class="btn btn-outline-secondary btn-lg text-uppercase px-4 mr-1"
          >
            <i class="fa fa-angle-left mr-2"></i>
            <span class="d-none d-md-inline-block"> Cancelar</span>
          </button>
          <button
            @click="confirmEmitQuotation()"
            class="btn btn-primary btn-lg text-uppercase px-4"
          >
            Confirmar<i class="fa fa-angle-right ml-2"></i>
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Modal Filtros -->
    <b-modal
      ref="modalFilter"
      id="modal-filter"
      size="lg"
      class="mt-4"
      centered
    >
      <template #modal-title>Filtrar Cotações</template>
      <form class="mb-2">
        <label>Número</label>
        <b-form-input
          class="mb-3"
          v-model="filtersTable.number"
          size="lg"
          id="name-input"
          required
        ></b-form-input>
        <label>Tomador</label>
        <b-form-input
          class="mb-3"
          v-model="filtersTable.policy_holder"
          size="lg"
          id="name-input"
          required
        ></b-form-input>

        <label>Segurado</label>
        <b-form-input
          v-model="filtersTable.insured"
          class="mb-3"
          size="lg"
          id="name-input"
          required
        ></b-form-input>

        <label for="">Processo</label>
        <b-form-input
          class="mb-3"
          v-model="filtersTable.process"
          size="lg"
          id="name-input"
          required
        ></b-form-input>

        <div id="filtros" class="row">
          <div class="col-12 col-lg-6 mb-3">
            <label>Tipo de seguro</label>
            <div class="input-group">
              <b-form-select v-model="filtersTable.insurance" class="mb-3">
                <b-form-select-option value="">Sem Filtro</b-form-select-option>
                <b-form-select-option
                  v-for="(value, index) in list_insurance"
                  :value="value.id"
                  :key="index"
                >
                  {{ value.name }}
                </b-form-select-option>
              </b-form-select>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <label>Seguradora</label>
            <div class="input-group">
              <b-form-select v-model="filtersTable.insurer" class="mb-3">
                <b-form-select-option value="">Sem Filtro</b-form-select-option>
                <b-form-select-option
                  v-for="(value, index) in list_insurers"
                  :value="index"
                  :key="index"
                >
                  {{ value }}
                </b-form-select-option>
              </b-form-select>
            </div>
          </div>
        </div>

        <label>Status</label>
        <b-form-select
          v-model="filtersTable.status"
          :options="options()"
          class="mb-3"
        ></b-form-select>

        <label>Data da Criação</label>
        <div id="filtros" class="row">
          <div class="col-12 col-lg-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">de</span>
              </div>
              <b-form-datepicker
                id="datepicker-dateformat1"
                locale="pt-BR"
                nav-button-variant="white"
                v-model="filtersTable.start_created"
                menu-class="w-100"
                calendar-width="100%"
                :show-decade-nav="false"
                :hide-header="true"
                placeholder="dd/mm/aaaa"
              ></b-form-datepicker>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">até</span>
              </div>
              <b-form-datepicker
                id="datepicker-dateformat2"
                locale="pt-BR"
                nav-button-variant="white"
                v-model="filtersTable.end_created"
                menu-class="w-100"
                calendar-width="100%"
                :show-decade-nav="false"
                :hide-header="true"
                placeholder="dd/mm/aaaa"
              ></b-form-datepicker>
            </div>
          </div>
        </div>
      </form>
      <template #modal-footer>
        <b-button @click="filterQuotations()" variant="outline-primary">
          Filtrar <i class="fa fa-search"></i>
        </b-button>
      </template>
    </b-modal>

    <!-- Modal de informações da cotação -->
    <b-modal
      id="show-modal-info-quotation"
      ref="showModalInfoQuotation"
      size="lg"
      class="mt-4"
      hide-footer
      centered
      no-stacking
      @shown="checkOverflow"
      @hidden="resetToggleValues"
    >
      <template #modal-title>Informações da cotação</template>
      <div class="modal-informacao-erros">
        <b-card-group
          v-if="exception.length === 0"
          class="d-flex justify-content-center"
        >
          <h6 class="modal-title">Essa cotação não possui retornos.</h6>
        </b-card-group>
        <b-card-group
          deck
          class="mt-2 mb-3 card-informacao-erros"
          v-for="(item, index) in exception"
          :key="item.id"
        >
          <b-card
            border-variant="primary"
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <template #header>
              <div
                @click="setToggleModalExceptionValue(index)"
                class="cursor-pointer"
              >
                {{ setModalExceptionHeader(item.insurer_identifier, index) }}
                <i
                  :class="[
                    'mdi',
                    toggle_value[index] ? 'mdi-chevron-down' : 'mdi-chevron-up',
                  ]"
                ></i>
              </div>
            </template>
            <div v-if="toggle_value[index]">
              <div class="col-12 col-lg-12 mb-3">
                <label class="dbo-ui"><strong>Seguradora</strong></label>
                <p>
                  {{
                    getEnumKeyByEnumValue(
                      translateInsurersTypes,
                      item.insurer_identifier
                    )
                  }}
                </p>
              </div>

              <hr />
              <div class="col-12 col-lg-12 mb-3">
                <label class="dbo-ui"><strong>Endpoint</strong></label>
                <p>{{ jsonParse(item.endpoint) }}</p>
              </div>

              <hr />
              <div class="col-12 col-lg-12 mb-3">
                <label class="dbo-ui"><strong>Payload</strong></label>
                <pre
                  class="json-box"
                  :class="{ expanded: isPreExpanded(index, 'payload') }"
                  :data-key="preKey(index, 'payload')"
                >{{ formatJson(item.payload) }}</pre>
                <button
                  v-if="overflowing[preKey(index, 'payload')]"
                  type="button"
                  class="btn btn-link btn-sm p-0 ver-mais-btn"
                  @click="togglePre(index, 'payload')"
                >
                  {{ isPreExpanded(index, "payload") ? "Ver menos" : "Ver mais" }}
                </button>
              </div>

              <hr />
              <div class="col-12 col-lg-12 mb-3">
                <label class="dbo-ui"><strong>Retorno</strong></label>
                <pre
                  class="json-box"
                  :class="{ expanded: isPreExpanded(index, 'exception') }"
                  :data-key="preKey(index, 'exception')"
                >{{ formatJson(item.exception) }}</pre>
                <button
                  v-if="overflowing[preKey(index, 'exception')]"
                  type="button"
                  class="btn btn-link btn-sm p-0 ver-mais-btn"
                  @click="togglePre(index, 'exception')"
                >
                  {{ isPreExpanded(index, "exception") ? "Ver menos" : "Ver mais" }}
                </button>
              </div>
            </div>
          </b-card>
        </b-card-group>
      </div>
      <hr />
      <div
        v-if="quotation_status == statusQuotationTypes.ISSUE_FAILURE"
        class="col-12 col-lg-12 my-3"
      >
        <button v-b-modal.show-modal-update class="btn btn-primary">
          Retornar cotação a fila
        </button>
      </div>
    </b-modal>

    <!-- Modal para retornar status da cotação -->
    <b-modal
      id="show-modal-update"
      ref="showModalUpdate"
      size="md"
      class="mt-4"
      hide-footer
      centered
    >
      <template #modal-title>Retornar status da cotação</template>
      <div class="row mb-3">
        <div class="col-12 col-lg-12">
          <h6>
            Deseja retornar Cotação para a fila trocando o status dela para
            aprovada?
          </h6>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12">
          <button
            @click="
              $refs.showModalUpdate.hide(), $refs.showModalInfoQuotation.show()
            "
            class="btn btn-outline-secondary btn-lg text-uppercase px-4 mr-1"
          >
            <i class="fa fa-angle-left mr-2"></i>
            <span class="d-none d-md-inline-block">Voltar</span>
          </button>
          <button
            class="btn btn-primary btn-lg text-uppercase px-4"
            @click="quotationIssueResend"
          >
            Confirmar<i class="fa fa-angle-right ml-2"></i>
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import quotationService from "@/services/quotation";
import dateFormatter from "@/mixins/dateFormatter";
import numericFormatterMixin from "@/mixins/numericFormatter";
import translateInsuranceTypes from "@/enums/translate/insuranceTypes";
import translateInsurersTypes from "@/enums/translate/insurersTypes";
import insuranceCategoryTecnicTypes from "@/enums/translate/insuranceCategoryTecnicTypes";
import commomsHelper from "@/mixins/commomsHelper";
import authenticationService from "@/services/authentication";
import statusQuotationTypes from "@/enums/statusQuotationTypes";
import uiHelperMixin from "@/mixins/uiHelper";
import tableHelperMixin from "@/mixins/tableHelper";
import translateStatusQuotationTypes from "@/enums/translate/statusQuotationTypes";
import policyService from "@/services/policy";

export default {
  name: "list-quotation",
  mixins: [
    numericFormatterMixin,
    dateFormatter,
    commomsHelper,
    uiHelperMixin,
    tableHelperMixin,
  ],
  data: () => ({
    items: [],
    translateInsuranceTypes: translateInsuranceTypes,
    translateInsurersTypes: translateInsurersTypes,
    insuranceCategoryTecnicTypes: insuranceCategoryTecnicTypes,
    translateStatusQuotationTypes: translateStatusQuotationTypes,
    routeRedirect: "list-quotation",
    title: "Excluir cotação",
    deletion_data: "",
    current_deletion: "",
    loading: false,
    checkPolice: true,
    exception: [],
    statusQuotationTypes: statusQuotationTypes,
    rows: 0,
    idConfirmClone: null,
    msgLoading: "Exclusão em andamento.",
    idConfirmEmit: null,
    nameTable: "quotations",
    quotation_id: null,
    quotation_status: null,
    list_insurers: [],
    list_insurance: [],
    toggle_value: {},
    expanded_pre: {},
    overflowing: {},
    collapsedMaxHeight: 160,
    current_mode: "Listagem",
    currentPage: 1,
    perPage: 10,
  }),
  async created() {
    this.getInsurers();
    this.getInsuranceCategories();

    if (this.$route.query.filter) {
      this.fillFilterForm();
      this.getQuotations();

      return;
    }

    this.cleanFilter();
  },
  computed: {
    allowedJudicialFlow() {
      return this.allowedJudicial();
    },
    totalPages() {
      return Math.ceil(this.rows / this.perPage) || 1;
    },
    // gera o array [1,2,…,totalPages]
    pages() {
      const total = this.totalPages;
      // se forem 3 ou menos, mostra todas
      if (total <= 3) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      // se estiver na primeira página, exibe [1,2,3]
      if (this.currentPage === 1) {
        return [1, 2, 3];
      }
      // se estiver na última, exibe [total-2,total-1,total]
      if (this.currentPage === total) {
        return [total - 2, total - 1, total];
      }
      // caso geral, exibe [current-1, current, current+1]
      return [this.currentPage - 1, this.currentPage, this.currentPage + 1];
    },
  },
  methods: {
    isMaster() {
      return authenticationService.isMaster();
    },
    isNotRentalInsurance(item) {
      return item.type !== 'Seguro Fiança Locatícia';
    },
    showModalExeption(val) {
      this.loadingQuotations();
      quotationService
        .getFailedQuote(val.action, val.insurer)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.exception = response.data;
          this.$refs.showModalInfoQuotation.show();
          this.quotation_id = val.action;
          this.quotation_status = val.status;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showModalDestroy(val) {
      this.current_deletion = val.action;
      this.deletion_data = "Deseja realmente excluir os dados de " + val.taker;
      this.$refs.showModal.show();
    },
    jsonParse(str) {
      return this.isJsonString(str) ? JSON.parse(str) : str;
    },
    formatJson(str) {
      const value = this.jsonParse(str);
      if (value && typeof value === "object") {
        return JSON.stringify(value, null, 2);
      }
      return value;
    },
    preKey(index, type) {
      return `${index}-${type}`;
    },
    togglePre(index, type) {
      const key = this.preKey(index, type);
      this.$set(this.expanded_pre, key, !this.expanded_pre[key]);
    },
    isPreExpanded(index, type) {
      return !!this.expanded_pre[this.preKey(index, type)];
    },
    checkOverflow() {
      this.$nextTick(() => {
        const nodes = document.querySelectorAll(
          "#show-modal-info-quotation .json-box"
        );
        const result = { ...this.overflowing };
        nodes.forEach((el) => {
          const key = el.dataset.key;
          if (key) {
            // scrollHeight reflects the full content height even when the box
            // is collapsed (overflow hidden), so we can detect real overflow.
            result[key] = el.scrollHeight > this.collapsedMaxHeight + 5;
          }
        });
        this.$set(this, "overflowing", result);
      });
    },
    checkPolicyExist() {
      this.loading = true;
      this.msgLoading = "Verificando apólice.";
      this.$refs.showModal.hide();
      quotationService
        .getByUID(this.current_deletion)
        .then((response) => {
          if (response.data && response.data.policies && response.data.policies.length > 0) {
            this.deletion_data =
              "Existe uma apólice de seguro vinculada a esta cotação, deseja realmente excluí-la?";
            this.checkPolice = false;
            this.$refs.showModal.show();
            return;
          }
          this.destroyQuotation();
        })
        .catch(() => {
          this.showError("Não foi possível recuperar as cotações.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    verifyStatusQuotation(status) {
      return (
        status == this.statusQuotationTypes.ISSUED ||
        status == this.statusQuotationTypes.APPROVED ||
        status == this.statusQuotationTypes.ISSUE
      );
    },
    actionAvaiable(status) {
      return status == this.statusQuotationTypes.ISSUE;
    },
    destroyQuotation() {
      this.loading = true;
      this.msgLoading = "Exclusão em andamento.";
      this.$refs.showModal.hide();
      quotationService
        .destroy(this.current_deletion)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.getQuotations();
        })
        .catch(() => {
          this.showError("Não foi possível remover a cotação.");
        })
        .finally(() => {
          this.checkPolice = true;
          this.loading = false;
        });
    },
    editQuotation(id, status) {
      if (status == this.statusQuotationTypes.ISSUED) {
        return;
      }
      quotationService
        .getByUID(id)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          const quotation = response.data;
          const routeName = this.verifyCurrentRouteName(quotation);
          this.redirect(routeName, { quotationId: quotation.id });
          return;
        })
        .catch(() => {
          this.showError("Não foi possível recuperar as cotações.");
        });
    },
    cloneQuotation(id) {
      this.idConfirmClone = id;
      this.$refs["showModalConfirmClone"].show();
    },
    confirmCloneQuotation() {
      this.loading = true;
      this.msgLoading = "Cópia de cotação em andamento.";
      this.$refs.showModalConfirmClone.hide();
      quotationService
        .clone(this.idConfirmClone)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.redirect("garantee-data", {
            quotationId: response.data.id,
          });
          this.idConfirmClone = null;
        })
        .catch(() => {
          this.showError("Não foi possível clonar a cotação.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    emitQuotation(id) {
      this.idConfirmEmit = id;
      this.$refs["showModalConfirmEmit"].show();
    },
    confirmEmitQuotation() {
      this.loading = true;
      this.msgLoading = "Emissão da apólice em andamento.";
      this.$refs.showModalConfirmEmit.hide();
      quotationService
        .emitQuotation(this.idConfirmEmit)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.idConfirmEmit = null;
          this.redirect("create-edit-policy", { policyId: response.data.id });
        })
        .catch((error) => {
          this.showError(
            "Não foi possível emitir a apólice. " + error.response.data.error
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    verifyCurrentRouteName(quotation) {
      if (!quotation.insurance_type_id || !quotation.insurance_category_id) {
        return "garantee-types-selection";
      }

      if (!quotation.document || !quotation.name || !quotation.guarantee) {
        return "garantee-data";
      }

      if (!quotation.insured || !quotation.insured.address) {
        return "insured-data";
      }

      if (
        !quotation.guarantee.contract_number ||
        !quotation.guarantee.guarantee_object ||
        !quotation.guarantee.contract_value
      ) {
        return "quotation-details";
      }

      if (!quotation.guarantee.insurer_selected) {
        return "quotation-summary";
      }
    },
    getQuotations() {
      this.resetAlert();
      this.loadingQuotations();
      quotationService
        .get(this.getFilterForm())
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.rows = response.data.total;
          this.formatList(response.data);
          this.loading = false;
        })
        .catch(() => {
          this.showError("Não foi possível recuperar as cotações.");
        })
        .finally(() => {
          this.loading = false;
          this.msgLoading = "Exclusão em andamento.";
        });
    },
    getEnumKeyByEnumValue(myEnum, enumValue) {
      let keys = Object.keys(myEnum).filter((x) => myEnum[x] == enumValue);
      return keys.length > 0 ? keys[0] : null;
    },
    formatList(data) {
      this.items = data.data.map((element) => ({
        number: element.number,
        award: element.award,
        type: element.insurance_category_id ? this.getEnumKeyByEnumValue(
          this.insuranceCategoryTecnicTypes,
          element.insurance_category_id
        ) : this.getEnumKeyByEnumValue(
          this.translateInsuranceTypes,
          element.insurance_type_id
        ),
        value_insured: element.guarantee
          ? this.allowedJudicialFlow.indexOf(element.insurance_category_id) !=
            -1
            ? this.formatCurrency(element.guarantee.contract_value)
            : this.formatCurrency(element.guarantee.guarantee_value)
          : "R$ 0,00",
        taker: element.name,
        status: element.status,
        insured: element.insured ? element.insured.name : null,
        created_at: this.formatDateTimeLocal(element.created_at),
        action: element.id,
        failed_quote: element.failed_quote,
        insurer: element.guarantee ? element.guarantee.insurer_selected : null,
        policy_id: element.policy_id,
        policy_number: element.policy_number,
        insurer_icon: element.insurer_icon ?? null,
      }));
    },
    redirect(routeName, params = {}) {
      this.$router.push({ name: routeName, params: params });
    },
    filterQuotations() {
      this.currentPage = 1;
      this.setFilterForm();
      this.getQuotations();
      this.$refs.modalFilter.hide();
    },
    cleanFilter() {
      this.currentPage = 1;
      this.filtersTable = {
        number: "",
        policy_holder: "",
        process: "",
        insured: "",
        status: null,
        start_created: "",
        end_created: "",
        document: "",
        insurer: "",
        insurance: "",
      };
      this.setFilterForm();
      this.getQuotations();
    },
    sortingTableChanged(e) {
      this.sortBy = e.sortBy;
      this.sortDesc = e.sortDesc;
      this.setFilterForm();
      this.getQuotations();
    },

    loadingQuotations() {
      this.msgLoading = "";
      this.loading = true;
    },
    options() {
      let options = [];
      let status = Object.entries(this.translateStatusQuotationTypes);
      status.forEach((element) => {
        options.push({ value: element[1], text: element[0] });
      });
      options.sort(function (a, b) {
        return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
      });
      options.splice(0, 0, {
        value: null,
        text: "Sem Filtro",
        notEnabled: true,
        disabled: true,
      });
      return options;
    },
    quotationIssueResend() {
      this.msgLoading = "";
      this.loading = true;
      quotationService
        .quotationIssueResend(this.quotation_id)
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
        })
        .catch(() => {
          this.showError("Não foi possível alterar status da cotação.");
        })
        .finally(() => {
          this.$bvModal.hide("show-modal-update");
          this.getQuotations();
          this.loading = false;
          this.msgLoading = "Exclusão em andamento.";
        });
    },
    getInsurers() {
      policyService
        .getInsurers()
        .then((response) => {
          this.list_insurers = response.data;
        })
        .catch(() => {
          this.showError("Não foi possível recuperar a lista de seguradoras.");
        });
    },
    getInsuranceCategories() {
      policyService
        .getAllInsuranceCategories()
        .then((response) => {
          this.list_insurance = response.data;
        })
        .catch(() => {
          this.showError("Não foi possível recuperar a lista de modalidades.");
        });
    },
    setToggleModalExceptionValue(index) {
      if (this.toggle_value[index] === undefined) {
        this.$set(this.toggle_value, index, true);
      } else {
        this.$set(this.toggle_value, index, !this.toggle_value[index]);
      }
      this.checkOverflow();
    },
    setModalExceptionHeader(insurer_identifier, index) {
      var message = `Request n° ${index} `;
      if (insurer_identifier != null) {
        return (
          message +
          " - " +
          this.getEnumKeyByEnumValue(
            this.translateInsurersTypes,
            insurer_identifier
          )
        );
      }
      return message;
    },
    resetToggleValues() {
      this.$set(this, "toggle_value", []);
      this.$set(this, "expanded_pre", {});
      this.$set(this, "overflowing", {});
    },
    getIcon(currentMode) {
      if (currentMode === "Listagem") {
        return "mdi mdi-view-list mr-1";
      }
      if (currentMode === "painel") {
        return "mdi mdi-file-table-box-multiple-outline mr-2";
      }
      return "mdi fa-fw mdi-chart-arc mr-1";
    },
    setViewMode(mode) {
      this.current_mode = mode;
      if (mode == "painel") {
        this.redirect("kanban-quotation");
      }
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage)
        return;
      this.currentPage = page;
      this.pageChanged(null, page);
    },

    pageChanged(bvEvent, pageNumber) {
      this.currentPage = pageNumber;
      this.setFilterForm();
      this.getQuotations();
    },
  },
};
</script>

<style>
.json-box {
  white-space: pre-wrap;
  word-break: break-word;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 4px;
  max-height: 160px;
  overflow: hidden;
  transition: max-height 0.25s ease;
}

.json-box.expanded {
  max-height: 70vh;
  overflow: auto;
}

.ver-mais-btn {
  font-size: 0.85rem;
  text-decoration: none;
}

.ver-mais-btn:hover {
  text-decoration: underline;
}
</style>
